module.exports = __webpack_public_path__ + "static/img/bg_boss_header.045384e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/subordinate-details/bg_boss_header.png
// module id = DmLF
// module chunks = 1